import { useCallback } from 'react';
import { useAppSelector } from '@src/core/hooks';
import { appInfoLoadedSelector, featureFlagsSelector } from '@src/stores/app';

type FeatureFlagHook = {
  areFeatureFlagsReady: boolean;
  isFeatureFlagEnabled: (feature: keyof typeof FeatureFlags) => boolean;
};

export const FeatureFlags = {
  'PR-1858-new-phone-input': true,
  'PR-2195-collect-buyer-birthdate': true,
  'PR-2195-collect-buyer-cep': true,
  'PR-646-product-packages': true,
  'preview-seat-map': true,
  'PR-3221-seat-map': true,
  'PR-3691-charged-reschedule': true,
  'PR-647-service-fee': true,
  'PR-3997-new-purchase-flow': true,
  'PR-4007-upsell': true,
  'PR-4664-product-package-single-journey': true,
  'PR-3043-checkout': true,
  'PR-4836-cashback-growth': true,
};

export const useFeatureFlag = (): FeatureFlagHook => {
  const appInfoLoaded = useAppSelector(appInfoLoadedSelector);
  const featureFlags = useAppSelector(featureFlagsSelector());

  const isFeatureFlagEnabled = useCallback(
    (feature: keyof typeof FeatureFlags): boolean => {
      if (!appInfoLoaded) {
        return false;
      }

      if (!featureFlags) {
        console.warn('Feature flags not found. Check if it is correctly configured.');
        return false;
      }

      if (!(feature in featureFlags) || featureFlags[feature] === undefined) {
        console.warn(`Feature flag ${feature} not found. Check if it is correctly configured.`);
        return false;
      }

      return featureFlags[feature];
    },
    [appInfoLoaded, featureFlags],
  );

  return {
    areFeatureFlagsReady: appInfoLoaded,
    isFeatureFlagEnabled,
  };
};

export default useFeatureFlag;
